import { render, staticRenderFns } from "./oxygenPointHistory.vue?vue&type=template&id=bb0f5b64&"
import script from "./oxygenPointHistory.vue?vue&type=script&lang=js&"
export * from "./oxygenPointHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports